var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("clientLogo clientLogo--" + _vm.type + (!_vm.hasLogo ? ' clientLogo--noLogo' : ''))},[(_vm.hasLogo)?_c('img',{staticClass:"clientLogo__img",attrs:{"src":_vm.clientLogo}}):_c('span',{staticClass:"clientLogo__text"},[_vm._v("Please upload logo")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4677c530","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientLogo/client-logo.vue
// module id = null
// module chunks = 